<template>
    <multiple_form
      :forms="forms"
      :edit="props.isEdit"
      :editData="props.editData"
      :itemCol="24"
      @submit="handelSubmit"
    />
</template>
<script setup>
    import { defineProps, defineEmits, computed } from 'vue'
    import { message } from 'ant-design-vue'
    import { updateAmend } from '@/api/person_application/person_application_approval'
    import multiple_form from '@/components/multiple_form'
    //初始化
    const props = defineProps({
      isEdit: Boolean,
      editData: Object,
      data: Array,
      idField: String,
    })
    const emit = defineEmits(['submit'])
  
    //编辑、新增的表单
    const forms = computed(() => [
      {
        id: 'visiting_information',
        itemWidth: '420px',
        dataInObject: 'personApplication',
        formItem: [
          {
            type: 'dateRange',
            startField: 'visit_begin_time',
            endField: 'visit_end_time',
            label: '来访时间',
          },
        ],
      },
    ])
  
    async function handelSubmit(data) {
      const res = await updateAmend({
        ...data,
        person_application_id: props.editData['ref_id'],
        process_instance_id: props.editData['process_instance_id'],
      })
      if (res.success) {
        message.success('编辑成功！')
        emit('submit')
      } else {
        message.warn('编辑错误：', res.message)
      }
    }
  
</script>  